import PageHeader from 'components/organisms/PageOutlines/PageHeader';
import PageWrapper from 'components/organisms/PageOutlines/PageWrapper';
import { Spinner } from 'components/widgets';
import { Formik } from 'formik-2';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { withLocalize } from 'react-localize-redux';
import { useSelector } from 'react-redux';
import { getIsAgency } from '../selectors/user';
import toaster from '../utils/toaster';
import ExternalOrgProfileForm from './components/ExternalOrgProfileForm';
import css from './page.css';
import service from './service';

const translationPrefix = 'STATIC.PAGES.EXTERNAL_ORG_PROFILE';

const INITIAL_PROFILE = {
    companyName: '',
    agencyId: '',
    website: '',
    description: '',
    tags: [],
    logoUrl: '',
    logoFile: null,
};

const hasRequiredFields = ({ website, hasLogo }) => Boolean((website || '').trim()) && Boolean(hasLogo);

const ExternalOrgProfile = ({ translate }) => {
    const isAgency = useSelector(getIsAgency);
    const [savedProfile, setSavedProfile] = useState(INITIAL_PROFILE);
    const [isLoading, setIsLoading] = useState(true);
    const shouldRedirectAfterFirstSaveRef = useRef(false);

    useEffect(() => {
        service
            .getProfile()
            .then(data => {
                const profileData = {
                    companyName: data.company_name || '',
                    agencyId: data.agency_id || '',
                    website: data.website || '',
                    description: data.description || '',
                    tags: data.tags || [],
                    logoUrl: data.logo_url || '',
                    logoFile: null,
                };
                const isInitiallyValid = hasRequiredFields({
                    website: profileData.website,
                    hasLogo: Boolean(profileData.logoUrl.trim()),
                });
                shouldRedirectAfterFirstSaveRef.current = !isInitiallyValid;
                setSavedProfile(profileData);
            })
            .catch(() =>
                toaster.error(
                    translate(`${translationPrefix}.MESSAGES.${isAgency ? 'AGENCY_LOAD_ERROR' : 'LOAD_ERROR'}`)
                )
            )
            .finally(() => setIsLoading(false));
    }, [translate, isAgency]);

    return (
        <PageWrapper className={css.wrapper} disablePadding>
            <PageHeader
                text={isAgency ? `${translationPrefix}.AGENCY_PAGE_TITLE` : `${translationPrefix}.PAGE_TITLE`}
                subText={{
                    subTitle: isAgency
                        ? `${translationPrefix}.AGENCY_PAGE_SUBTITLE`
                        : `${translationPrefix}.PAGE_SUBTITLE`,
                }}
                shouldAddPadding
                className={css.pageHeader}
            />
            {isLoading ? (
                <Spinner expanded show />
            ) : (
                <Formik initialValues={savedProfile} enableReinitialize>
                    <ExternalOrgProfileForm
                        translate={translate}
                        setSavedProfile={setSavedProfile}
                        shouldRedirectAfterFirstSaveRef={shouldRedirectAfterFirstSaveRef}
                    />
                </Formik>
            )}
        </PageWrapper>
    );
};

ExternalOrgProfile.propTypes = {
    translate: PropTypes.func.isRequired,
};

export default withLocalize(ExternalOrgProfile);
